import { View, ActionIcon, SearchInput, AvatarInfo } from '@/components'
import { navigation, StyleRegistry, StyleSheets } from '@/config'
import { useIsTablet } from '@/hooks'
import { StyledComponent, useNestedStylesByKey } from '@codeleap/styles'
import { PropsOf } from '@codeleap/types'
import { useStylesFor } from '@codeleap/web'
import { DrawerMenu } from './Header/Drawer'

type PageHeaderProps = Omit<PropsOf<typeof View>, 'style'> & {
  searchInputProps?: Partial<PropsOf<typeof SearchInput>>
  actionIconProps?: PropsOf<typeof ActionIcon>
  avatarInfoProps?: PropsOf<typeof AvatarInfo>
  canGoBack?: boolean
}

export const PageHeader: StyledComponent<typeof StyleSheets.PageHeaderStyles, PageHeaderProps> = (props) => {
  const {
    actionIconProps,
    searchInputProps,
    avatarInfoProps,
    style,
    canGoBack,
    ...wrapperProps
  } = props

  const isTablet = useIsTablet()

  const styles = useStylesFor(PageHeader.styleRegistryName, style)
  const backActionIconStyles = useNestedStylesByKey('backActionIcon', styles)
  const avatarInfoStyles = useNestedStylesByKey('avatarInfo', styles)
  const searchInputStyles = useNestedStylesByKey('searchInput', styles)
  const contentActionIconStyles = useNestedStylesByKey('contentActionIcon', styles)

  return (
    <View style={[styles.wrapper]} {...wrapperProps}>
      <View style={styles.innerWrapper}>
        {canGoBack && (
          <ActionIcon
            debugName='go-back-header'
            icon='chevron-left'
            style={backActionIconStyles}
            onPress={navigation.context?.router?.back}
          />
        )}
        <View style={styles.contentWrapper}>
          <View style={styles.infoWrapper}>
            {!canGoBack && isTablet ? (
              <DrawerMenu styles={styles} />
            ) : null}

            <AvatarInfo
              {...avatarInfoProps}
              style={avatarInfoStyles}
            />
          </View>

          {(searchInputProps || actionIconProps) && (
            <View style={styles.actionWrapper}>
              {searchInputProps && (
                <SearchInput
                  // @ts-ignore
                  {...searchInputProps}
                  style={['flex', 'noError', 'radius:small', 'height:largeish', 'bg:default', 'border:small', searchInputStyles]}
                />
              )}

              {actionIconProps && (
                <ActionIcon
                  debugName='header-content-actionIcon'
                  {...actionIconProps}
                  style={contentActionIconStyles}
                />
              )}
            </View>
          )}
        </View>

      </View>
    </View>
  )
}

PageHeader.styleRegistryName = 'PageHeader'
PageHeader.elements = ['wrapper', 'contentWrapper', 'innerWrapper', 'infoWrapper', 'actionWrapper', 'backActionIcon', 'contentActionIcon', 'avatarInfo', 'searchInput']

StyleRegistry.registerComponent(PageHeader)
